import { Component, ErrorInfo, ReactNode } from "react";
import { reportError } from "@/utils/reportError";

type Props = { fallback: ReactNode; children: ReactNode };
type State = { hasError: boolean };

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    reportError(error, {
      eventName: "FE-ERROR-BOUNDARY",
      errorCode: "react.errorBoundary",
      errorMessage: errorInfo.componentStack ?? undefined,
    });
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
